<template>
  <div class="login-page">
    <el-card class="login-card">
      <h2 class="login-title">管理员登录</h2>
      <!-- 1. 增加表单验证规则（必填、密码长度） -->
      <el-form 
        :model="form" 
        :rules="loginRules" 
        ref="loginFormRef" 
        label-width="80px"
      >
        <el-form-item label="账号" prop="username">
          <el-input 
            v-model="form.username" 
            placeholder="请输入管理员账号"
            clearable 
            @keyup.enter.native="handleLogin"
          ></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input 
            v-model="form.password" 
            type="password" 
            placeholder="请输入密码（至少6位）"
            show-password 
            @keyup.enter.native="handleLogin"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button 
            type="primary" 
            class="login-btn" 
            @click="handleLogin"
            :loading="loginLoading"  
          >
            登录
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import request from "@/helper/request";
import CryptoJS from "crypto-js";

import { adminLogin } from "@/api/admin";
export default {
  name: "AdminLogin",
  data() {
    return {
      form: {
        username: "",
        password: ""
      },
      // 2. 表单验证规则
      loginRules: {
        username: [
          { required: true, message: "请输入管理员账号", trigger: "blur" },
          { min: 3, max: 20, message: "账号长度需在3-20位之间", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          { min: 6, max: 32, message: "密码长度需在6-32位之间", trigger: "blur" }
        ]
      },
      loginLoading: false  // 登录加载状态
    };
  },
  methods: {
    async handleLogin() {
      this.$refs.loginFormRef.validate(async (isValid) => {
        if (!isValid) return;

        this.loginLoading = true;
        try {
          const res = await adminLogin({
            username: this.form.username,
            password: this.form.password
          });

          if (res.data.status === 200) {
            localStorage.setItem("adminToken", res.data.data.token);
            this.$message.success("登录成功，正在跳转...");
            setTimeout(() => {
              this.$router.push("/admin/product");
            }, 1000);
          } else {
            localStorage.removeItem("adminToken");
            this.$message.error(res.data.msg || "登录失败，请检查账号密码");
          }
        } catch (err) {
          localStorage.removeItem("adminToken");
          console.error("登录接口错误:", err);
          this.$message.error("请求失败，请检查网络或稍后重试");
        } finally {
          this.loginLoading = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: #f5f5f5;
}
.login-card {
  width: 400px;
  padding: 30px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1); /* 增加阴影，提升视觉效果 */
}
.login-title {
  text-align: center;
  margin-bottom: 25px;
  color: #1890ff; /* 主题色，与按钮颜色一致 */
}
.login-btn {
  width: 100%; /* 按钮占满宽度，提升易用性 */
}
</style>